/* eslint-disable import/prefer-default-export */
import React from 'react'
import { ColumnType, ColumnProps } from '@src/components/data.grid'
import generateDetailsLink from '@src/utils/generate.details.link'
import { NavLink } from 'react-router-dom'
import { userActivityColumns } from '../../search.result/configurations'
import type { History } from 'history'
import { UsageItem } from '@src/redux/reducers/user.usage'

interface GetResourceNameProps {
  resource_uri?: string
  resource_name?: string
  resource_account_id?: string
  resource_type?: string
}

const getResourceName = ({
  resource_uri,
  resource_name,
  resource_account_id,
  resource_type
}: GetResourceNameProps) =>
  resource_uri && resource_account_id && resource_type ? (
    <NavLink to={generateDetailsLink(resource_uri)}>{resource_name}</NavLink>
  ) : (
    resource_name
  )

interface EventNameColumnProps {
  event_name?: string
  resource_uri?: string
  resource_name?: string
  resource_account_id?: string
  resource_type?: string
}

const EventNameColumn = ({
  event_name,
  resource_uri,
  resource_name,
  resource_account_id,
  resource_type
}: EventNameColumnProps) => (
  <span>
    {event_name}
    {resource_name && (
      <span>
        {' '}
        (
        {getResourceName({
          resource_uri,
          resource_name,
          resource_account_id,
          resource_type
        })}
        )
      </span>
    )}
  </span>
)

type ExtColumnProps<T> = ColumnProps<T> & { isFilterColumn?: boolean }

const columns = ({
  history
}: {
  history?: History
}): ExtColumnProps<UsageItem>[] => [
  {
    field: 'event_name',
    title: 'Event Name',
    isFilterColumn: true,
    template: row => EventNameColumn(row.original || {})
  },
  {
    field: 'ip_address',
    title: 'IP Address',
    isFilterColumn: true
  },
  {
    field: 'user_agent',
    title: 'User Agent'
  },
  {
    field: 'timestamp',
    title: 'Timestamp',
    type: ColumnType.datetime
  }
]

interface GetUserActivityColumns {
  history?: History
  hasQuery?: boolean
}

export const getUserActivityColumns = ({
  history,
  hasQuery
}: GetUserActivityColumns) => {
  if (hasQuery) {
    return userActivityColumns({ history }) as ColumnProps<UsageItem>[]
  }
  return columns({ history })
}
